import type { ReactElement } from 'react';
import useSubscription from 'hooks/useSubscription';
import Checkbox from 'components/shared/Checkbox';
import { toCurrency } from 'utils/numbers';

type Props = {
  subscriptionConfirmed: boolean;
  setSubscriptionConfirmed: (confirmed: boolean) => void;
};

function SubscriptionCheckbox({
  subscriptionConfirmed,
  setSubscriptionConfirmed,
}: Props): ReactElement {
  const { subscription } = useSubscription();
  const { signup_summary: signupSummary } = subscription;

  return (
    <div className="row">
      <div className="col-xs-12 col-md-12">
        <div className="c-form-group">
          <Checkbox
            id="weekly-subscription-agreement"
            checked={subscriptionConfirmed}
            onChange={(e) => {
              if (setSubscriptionConfirmed) {
                setSubscriptionConfirmed(e.target.checked);
              }
            }}
            label={(
              <>
                <p>
                  <strong>Confirm subscription</strong>
                </p>
                <p>
                  When you check this box, you agree to automatically renew your
                  subscription each week and allow us to charge your card
                  <span className="payment-method__subscription_agreement_plan_price">
                    &nbsp;
                    {toCurrency(signupSummary?.total_price || 0)}
                    *&nbsp;
                  </span>
                  + any applicable shipping (less any coupons or discounts) every
                  Wednesday. (*The amount charged may change depending on your order.)
                  You can cancel your subscription at any time, you just need to do so
                  by 11:59PM EST on Tuesday
                  <span className="u-text--italic">
                    &nbsp;the week before your next scheduled delivery&nbsp;
                  </span>
                  to avoid being charged for another box. You can cancel or change your
                  meal plan or payment method any time by logging into your account at
                  &nbsp;
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.purplecarrot.com/"
                  >
                    https://www.purplecarrot.com/
                  </a>
                  &nbsp;or by contacting us at&nbsp;
                  <a href="callto://857-703-8188">
                    857-703-8188
                  </a>
                  .
                </p>
                <p>
                  <a href="/terms?viewport=iframe">
                    Click here to review the Purple Carrot terms of service
                  </a>
                  .
                </p>
              </>
            )}
          />
        </div>
      </div>
    </div>
  );
}

export default SubscriptionCheckbox;
